<template>
  <button
    class="help-btn"
    @click="$emit('toggle')"
    :aria-label="ariaLabel"
    :title="ariaLabel"
  >
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="9.5" />
      <path d="M9.6 9 C9.6 7.5 10.7 6.4 12 6.4 C13.3 6.4 14.4 7.5 14.4 9 C14.4 10 13.5 10.6 12.9 11.1 C12.4 11.6 12 12.1 12 13" />
      <circle cx="12" cy="16.4" r="0.7" fill="currentColor" stroke="none" />
    </svg>
  </button>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { helpFor } from '@/config/help.config'

export default defineComponent({
  name: 'HelpButton',
  emits: ['toggle'],
  setup() {
    const route = useRoute()
    const ariaLabel = computed(() => {
      const entry = helpFor(route.meta.helpKey as string | undefined)
      return entry ? `Help — ${entry.title}` : 'Help'
    })
    return { ariaLabel }
  },
})
</script>

<style scoped>
.help-btn {
  width: 36px !important;
  height: 36px !important;
  min-width: 36px;
  margin: 0 !important;
  border-radius: 8px !important;
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  color: var(--vt-c-accent-light, #b4fcda);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none !important;
  transition: background 0.12s ease, color 0.12s ease;
  font-family: var(--font-sans);
  flex-shrink: 0;
}
.help-btn:hover {
  background: rgba(150, 255, 201, 0.12);
  color: var(--vt-c-accent, #96ffc9);
  transform: none !important;
  box-shadow: none !important;
}
.help-btn svg {
  width: 20px !important;
  height: 20px !important;
  flex-shrink: 0;
  display: block;
  stroke-width: 2;
}
</style>
